module.exports = "<ul id=\"container\">\n  <li class=\"wrapper\"><div id=\"name\">Survivalism</div></li>\n  <li class=\"wrapper\"><div class=\"option\">Menu</div></li>\n  <li class=\"wrapper\"><div class=\"option\">Menu 2</div></li>\n  <li class=\"wrapper\"><div class=\"option\">Menu 3</div></li>\n  <div class=\"spacer\"></div>\n  <li class=\"wrapper\"><div class=\"settings\">Settings</div></li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/navbar/navbar.component.html
// module id = ../../../../../src/app/navbar/navbar.component.html
// module chunks = main